function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Sidepanel, Button } from "../../../../Components/UI";
import { Translate, t } from "../../../../../I18N";
import { InputField, DateRangePicker, MultiSelect } from "../../../../Components/Forms";
import { useAtomValue } from 'jotai';

import { settingsAtom, localeAtom } from "../../../../atoms";






















const methodOptions = ['CREATE', 'UPDATE', 'DELETE', 'MIGRATE', 'WARNING'].map((method) => ({
  label: t('System', method, null, false).toUpperCase(),
  value: method
}));

const FiltersSidePanel = ({ isOpen, onClose, onSubmit, appliedFilters }) => {
  const { dateFormat = 'YYYY-MM-DD' } = useAtomValue(settingsAtom);
  const locale = useAtomValue(localeAtom);
  const [currentFilters, setCurrentFilters] = useState(appliedFilters);

  useEffect(() => {
    setCurrentFilters(appliedFilters);
  }, [appliedFilters]);

  const {
    register,
    control,
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: currentFilters
  });

  const handleInputSubmit =
  (field) => (e) => {
    setValue(field, e.target.value);
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      withOverlay: true,
      isOpen: isOpen,
      closeSidepanelFunction: onClose,
      title: /*#__PURE__*/_jsx(Translate, { className: "uppercase" }, void 0, "Filters") }, void 0, /*#__PURE__*/

    _jsx("form", {
      id: "activity-filters-form",
      onSubmit: handleSubmit(async (data) => onSubmit(data)),
      style: { width: '100%', overflowY: 'auto', scrollbarGutter: 'stable' } }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      value: currentFilters.method || [],
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Action"),
      options: methodOptions,
      onChange: (selected) => {
        setValue('method', selected);
      },
      hasErrors: !!errors.method,
      updatable: true }
    ), /*#__PURE__*/
    _jsx("div", { className: "p-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "username",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "User"),
      hasErrors: !!errors.username },
    register('username'), {
      clearFieldAction: () => {
        setValue('username', '');
      },
      onChange: handleInputSubmit('username'),
      onBlur: () => {} })
    ), /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "search",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Search"),
      className: "my-4",
      placeholder: t('System', 'by ids, methods, keywords, etc.', null, false) },
    register('search'), {
      clearFieldAction: () => {
        setValue('search', '');
      },
      onChange: handleInputSubmit('search'),
      hasErrors: !!errors.search,
      onBlur: () => {} })
    ), /*#__PURE__*/
    _jsx(Controller, {
      control: control,
      name: "dateRange",
      render: ({ field: { value }, fieldState }) => /*#__PURE__*/
      _jsx(DateRangePicker, {

        label: /*#__PURE__*/_jsx(Translate, { translationKey: "property daterange" }),
        language: locale,
        className: "pt-4 -top-4",
        placeholderStart: t('System', 'From', null, false),
        placeholderEnd: t('System', 'To', null, false),
        labelToday: t('System', 'Today', null, false),
        hasErrors: fieldState.error !== undefined,
        labelClear: t('System', 'Clear', null, false),
        from: (value === null || value === void 0 ? void 0 : value.from) || '',
        to: (value === null || value === void 0 ? void 0 : value.to) || '',
        onFromDateSelected: (e) => {
          setValue('dateRange.from', e.target.value);
          if (!getValues('dateRange.to')) {
            setValue('dateRange.to', e.target.value);
          }
        },
        onToDateSelected: (e) => {
          setValue('dateRange.to', e.target.value);
          if (!getValues('dateRange.from')) {
            setValue('dateRange.from', e.target.value);
          }
        },
        dateFormat: dateFormat,
        onClear: (field) => {
          setValue(`dateRange.${field}`, '');
          setCurrentFilters(_objectSpread(_objectSpread({},
          currentFilters), {}, {
            dateRange: _objectSpread(_objectSpread({}, currentFilters.dateRange), {}, { [field]: '' }) })
          );
        } }, "activity-log-range"
      ) }

    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      className: "flex-grow",
      type: "button",
      styling: "outline",
      onClick: () => {
        setCurrentFilters(_objectSpread(_objectSpread({},
        currentFilters), {}, {
          dateRange: { from: '', to: '' },
          to: '',
          method: [] })
        );
        reset({ username: '', method: [], search: '', dateRange: { from: '', to: '' } });
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Clear all")
    ), /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "submit" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Apply")
    )
    )
    )
    )
    ));

};
export { FiltersSidePanel };